/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_EditInputs */

const es_admin_company_overview_edit = /** @type {(inputs: Admin_Company_Overview_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar empresa`)
};

const en_admin_company_overview_edit = /** @type {(inputs: Admin_Company_Overview_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Company`)
};

/**
* | output |
* | --- |
* | "Edit Company" |
*
* @param {Admin_Company_Overview_EditInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_edit = /** @type {((inputs?: Admin_Company_Overview_EditInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_EditInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_edit(inputs)
	return en_admin_company_overview_edit(inputs)
});
export { admin_company_overview_edit as "admin.company_overview.edit" }